import(/* webpackMode: "eager" */ "/vercel/path0/apps/connect/src/app/login/page.tsx");
